import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { ARTICLES } from "@/lib/articles";
import { api } from "@/lib/api";
import { BlogHeader } from "@/components/BlogHeader";
import { Footer } from "@/components/Footer";

export default function Blog() {
  const { t, lang } = useLang();
  const [generated, setGenerated] = useState([]);

  useEffect(() => {
    document.title = t.blog.metaTitle;
    document.querySelector('meta[name="description"]')?.setAttribute("content", t.blog.metaDesc);
    window.scrollTo(0, 0);
  }, [t]);

  useEffect(() => {
    api.get("/blog/articles").then((r) => setGenerated(r.data || [])).catch(() => {});
  }, []);

  const all = [...generated, ...ARTICLES].sort((a, b) => (b.date || "").localeCompare(a.date || ""));

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <BlogHeader />
      <main className="max-w-5xl mx-auto px-6 pt-32 pb-20" data-testid="blog-page">
        <p className="text-xs uppercase tracking-[0.25em] text-[#FF7900] mb-3">{t.blog.overline}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold mb-4">{t.blog.title}</h1>
        <p className="text-white/50 text-base max-w-2xl mb-12">{t.blog.subtitle}</p>
        <div className="grid md:grid-cols-3 gap-6">
          {all.map((a) => {
            const c = a[lang] || a.fr;
            return (
              <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
                className="group border border-white/10 bg-[#111111] p-6 flex flex-col hover:border-[#FF7900]/60 transition-colors duration-300">
                <span className="text-[11px] uppercase tracking-widest text-[#FF7900] mb-3">{c.tag}</span>
                <h2 className="text-lg font-semibold leading-snug mb-3 group-hover:text-[#FF7900] transition-colors duration-300">{c.title}</h2>
                <p className="text-sm text-white/45 leading-relaxed mb-4 flex-1">{c.desc}</p>
                <span className="text-xs text-white/35">{new Date(a.date).toLocaleDateString(lang === "fr" ? "fr-BE" : "en-GB", { day: "numeric", month: "long", year: "numeric" })} · {t.blog.read}</span>
              </Link>
            );
          })}
        </div>
      </main>
      <Footer />
    </div>
  );
}
